import React from 'react';
import ACard from 'antd-mobile/lib/card';



export default class Card extends ACard {}
